import Icon from '../components/Icon.vue'

Icon.register({
  walking: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M208 96C234.5 96 256 74.5 256 48S234.5 0 208 0 160 21.5 160 48 181.5 96 208 96zM302.5 245.1L279.2 233.3 269.5 203.9C254.8 159.3 213.8 128.1 167.3 128 131.3 127.9 111.4 138.1 74 153.2 52.4 161.9 34.7 178.4 24.3 199.4L17.6 213C9.8 228.8 16.1 248 31.8 255.9 47.4 263.8 66.4 257.4 74.3 241.6L81 228C84.5 221 90.3 215.5 97.5 212.6L124.3 201.8 109.1 262.5C103.9 283.3 109.5 305.4 124 321.3L183.9 386.7C191.1 394.6 196.2 404.1 198.8 414.4L217.1 487.7C221.4 504.8 238.8 515.3 255.9 511 273 506.7 283.5 489.3 279.2 472.2L257 383.2C254.4 372.9 249.3 363.3 242.1 355.5L196.6 305.8 213.8 237.1 219.3 253.6C224.6 269.7 236 283 251 290.6L274.3 302.4C289.9 310.3 308.9 303.9 316.8 288.1 324.5 272.4 318.2 253 302.5 245.1zM73.6 385.8C70.4 393.9 65.6 401.2 59.4 407.3L9.4 457.4C-3.1 469.9-3.1 490.2 9.4 502.7S42.1 515.2 54.6 502.7L114 443.3C120.1 437.2 124.9 429.9 128.2 421.8L141.7 388C86.4 327.7 103 346.2 94.3 334.3L73.6 385.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/walking.js
// module id = D2Jw
// module chunks = 144